export var INCH_PIXEL_VALUE = 96;
export var CENTIMETER_PIXEL_VALUE = INCH_PIXEL_VALUE / 2.54;
export var MILLIMETER_PIXEL_VALUE = CENTIMETER_PIXEL_VALUE / 10;
export var QUARTER_PIXEL_VALUE = CENTIMETER_PIXEL_VALUE / 40;
export var PICA_PIXEL_VALUE = INCH_PIXEL_VALUE / 6;
export var POINT_PIXEL_VALUE = PICA_PIXEL_VALUE / 12;
//# sourceMappingURL=constants.js.map